import { render, staticRenderFns } from "./floor-management.vue?vue&type=template&id=2a904d78&scoped=true&"
import script from "./floor-management.vue?vue&type=script&lang=js&"
export * from "./floor-management.vue?vue&type=script&lang=js&"
import style0 from "./floor-management.vue?vue&type=style&index=0&id=2a904d78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a904d78",
  null
  
)

export default component.exports